import React, { ReactElement } from 'react';
import { ResponsiveContext } from 'slovlex-idsk-react-components';
import PravoEuRouter from './routing/PravoEuRouter';
import './main.scss';
import { ClientStatusContextProvider } from './context/ClientStatusContext';
import { SecurityContextProvider } from './context/SecurityContext';

// root component
const App = (): ReactElement => (
  <ResponsiveContext maxDesktopValuePx={640}>
    <SecurityContextProvider>
      <ClientStatusContextProvider>
        <PravoEuRouter />
      </ClientStatusContextProvider>
    </SecurityContextProvider>
  </ResponsiveContext>
);

export default App;
